import { ChangeDetectionStrategy, Component} from "@angular/core";

@Component({
	selector:'cp-button-strip',
	templateUrl: './button.strip.template.html',
	styleUrls: ['./button.strip.style.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class ButtonStripComponent  {
	
}
